/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminCrawlsRouteImport } from './routes/admin.crawls'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as AdminCrawlsIndexRouteImport } from './routes/admin.crawls.index'
import { Route as AdminCrawlsRequestIdRouteImport } from './routes/admin.crawls.$requestId'
import { Route as AdminProductsProductIdRouteImport } from './routes/admin.products.$productId'
import { Route as AdminVendorsIndexRouteImport } from './routes/admin.vendors.index'
import { Route as AdminVendorsVendorIdRouteImport } from './routes/admin.vendors.$vendorId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCrawlsRoute = AdminCrawlsRouteImport.update({
  id: '/crawls',
  path: '/crawls',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLeadsRoute = AdminLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCrawlsIndexRoute = AdminCrawlsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminCrawlsRoute,
} as any)
const AdminCrawlsRequestIdRoute = AdminCrawlsRequestIdRouteImport.update({
  id: '/$requestId',
  path: '/$requestId',
  getParentRoute: () => AdminCrawlsRoute,
} as any)
const AdminProductsProductIdRoute = AdminProductsProductIdRouteImport.update({
  id: '/products/$productId',
  path: '/products/$productId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVendorsIndexRoute = AdminVendorsIndexRouteImport.update({
  id: '/vendors/',
  path: '/vendors/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVendorsVendorIdRoute = AdminVendorsVendorIdRouteImport.update({
  id: '/vendors/$vendorId',
  path: '/vendors/$vendorId',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/signin': typeof SigninRoute
  '/admin/crawls': typeof AdminCrawlsRouteWithChildren
  '/admin/leads': typeof AdminLeadsRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/crawls/$requestId': typeof AdminCrawlsRequestIdRoute
  '/admin/products/$productId': typeof AdminProductsProductIdRoute
  '/admin/vendors/$vendorId': typeof AdminVendorsVendorIdRoute
  '/admin/crawls/': typeof AdminCrawlsIndexRoute
  '/admin/vendors/': typeof AdminVendorsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signin': typeof SigninRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/admin': typeof AdminIndexRoute
  '/admin/crawls/$requestId': typeof AdminCrawlsRequestIdRoute
  '/admin/products/$productId': typeof AdminProductsProductIdRoute
  '/admin/vendors/$vendorId': typeof AdminVendorsVendorIdRoute
  '/admin/crawls': typeof AdminCrawlsIndexRoute
  '/admin/vendors': typeof AdminVendorsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/signin': typeof SigninRoute
  '/admin/crawls': typeof AdminCrawlsRouteWithChildren
  '/admin/leads': typeof AdminLeadsRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/crawls/$requestId': typeof AdminCrawlsRequestIdRoute
  '/admin/products/$productId': typeof AdminProductsProductIdRoute
  '/admin/vendors/$vendorId': typeof AdminVendorsVendorIdRoute
  '/admin/crawls/': typeof AdminCrawlsIndexRoute
  '/admin/vendors/': typeof AdminVendorsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/signin'
    | '/admin/crawls'
    | '/admin/leads'
    | '/admin/'
    | '/admin/crawls/$requestId'
    | '/admin/products/$productId'
    | '/admin/vendors/$vendorId'
    | '/admin/crawls/'
    | '/admin/vendors/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signin'
    | '/admin/leads'
    | '/admin'
    | '/admin/crawls/$requestId'
    | '/admin/products/$productId'
    | '/admin/vendors/$vendorId'
    | '/admin/crawls'
    | '/admin/vendors'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/signin'
    | '/admin/crawls'
    | '/admin/leads'
    | '/admin/'
    | '/admin/crawls/$requestId'
    | '/admin/products/$productId'
    | '/admin/vendors/$vendorId'
    | '/admin/crawls/'
    | '/admin/vendors/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  SigninRoute: typeof SigninRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/crawls': {
      id: '/admin/crawls'
      path: '/crawls'
      fullPath: '/admin/crawls'
      preLoaderRoute: typeof AdminCrawlsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/leads': {
      id: '/admin/leads'
      path: '/leads'
      fullPath: '/admin/leads'
      preLoaderRoute: typeof AdminLeadsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/crawls/': {
      id: '/admin/crawls/'
      path: '/'
      fullPath: '/admin/crawls/'
      preLoaderRoute: typeof AdminCrawlsIndexRouteImport
      parentRoute: typeof AdminCrawlsRoute
    }
    '/admin/crawls/$requestId': {
      id: '/admin/crawls/$requestId'
      path: '/$requestId'
      fullPath: '/admin/crawls/$requestId'
      preLoaderRoute: typeof AdminCrawlsRequestIdRouteImport
      parentRoute: typeof AdminCrawlsRoute
    }
    '/admin/products/$productId': {
      id: '/admin/products/$productId'
      path: '/products/$productId'
      fullPath: '/admin/products/$productId'
      preLoaderRoute: typeof AdminProductsProductIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/vendors/': {
      id: '/admin/vendors/'
      path: '/vendors'
      fullPath: '/admin/vendors/'
      preLoaderRoute: typeof AdminVendorsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/vendors/$vendorId': {
      id: '/admin/vendors/$vendorId'
      path: '/vendors/$vendorId'
      fullPath: '/admin/vendors/$vendorId'
      preLoaderRoute: typeof AdminVendorsVendorIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminCrawlsRouteChildren {
  AdminCrawlsRequestIdRoute: typeof AdminCrawlsRequestIdRoute
  AdminCrawlsIndexRoute: typeof AdminCrawlsIndexRoute
}

const AdminCrawlsRouteChildren: AdminCrawlsRouteChildren = {
  AdminCrawlsRequestIdRoute: AdminCrawlsRequestIdRoute,
  AdminCrawlsIndexRoute: AdminCrawlsIndexRoute,
}

const AdminCrawlsRouteWithChildren = AdminCrawlsRoute._addFileChildren(
  AdminCrawlsRouteChildren,
)

interface AdminRouteChildren {
  AdminCrawlsRoute: typeof AdminCrawlsRouteWithChildren
  AdminLeadsRoute: typeof AdminLeadsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminProductsProductIdRoute: typeof AdminProductsProductIdRoute
  AdminVendorsVendorIdRoute: typeof AdminVendorsVendorIdRoute
  AdminVendorsIndexRoute: typeof AdminVendorsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCrawlsRoute: AdminCrawlsRouteWithChildren,
  AdminLeadsRoute: AdminLeadsRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminProductsProductIdRoute: AdminProductsProductIdRoute,
  AdminVendorsVendorIdRoute: AdminVendorsVendorIdRoute,
  AdminVendorsIndexRoute: AdminVendorsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  SigninRoute: SigninRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
